import { VizionApi } from '@ulysses-inc/harami_api_client'
import { PostVizionEmbedUrlResponse } from '@ulysses-inc/harami_api_client/dist/models'
import { call, put, takeLatest } from 'redux-saga/effects'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { errorVizionEmbedUrl, successVizionEmbedUrl } from './actions'
import { ActionTypes } from './types'

const postVizionEmbedUrlRequest = () => {
  return baseClient
    .getApi(VizionApi)
    .postVizionEmbedUrl()
    .then(response => response)
    .catch(handleHTTPError)
}

function* postVizionEmbedUrl() {
  try {
    const response: PostVizionEmbedUrlResponse = yield call(
      postVizionEmbedUrlRequest,
    )
    yield put(successVizionEmbedUrl(response.embedUrl || ''))
  } catch (e: unknown) {
    yield put(
      errorVizionEmbedUrl(e instanceof Error ? e.message : 'Unknown error'),
    )
  }
}

const sagas = [
  takeLatest(ActionTypes.REQUEST_VIZION_EMBED_URL, postVizionEmbedUrl),
]

export default sagas
